import { InjectionToken } from "@angular/core";
import { LangGraphAssistantId } from "./langgraph.types";

export const INTEGRATION_WEB_APP_URL = new InjectionToken<string>(
  'integrationWebAppUrl',
);
export const INTEGRATION_SUBSCRIPTION_KEY = new InjectionToken<string>(
  'integrationSubscriptionKey',
);
export const INTEGRATION_IQ_BOOST_URL = new InjectionToken<string>(
  'integrationIqBoostUrl',
);
export interface LangGraphConfig {
  // Without a trailing slash; empty where the orchestrator is not deployed.
  url: string;
  // Sent as `x-api-key`; empty where the deployment needs none (the local dev server).
  apiValue: string;
  assistantId: LangGraphAssistantId;
}
export const DEFAULT_LANGGRAPH_CONFIG: LangGraphConfig = {
  url: '',
  apiValue: '',
  assistantId: 'anonymized_mcp',
};
export const LANGGRAPH_CONFIG = new InjectionToken<LangGraphConfig>(
  'langGraphConfig',
);
